import React from 'react';
import PropTypes from 'prop-types';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';

const PartnerStats = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes } = generateGridStyles(gridStyles, name);
    const valsArray = Object.keys(val).map((key) => val[key] || '0');
    return (
        <p {...getHandlers(false)} style={stylers.wrapper} className={classes.wrapper} key={generateUniqueId()}>
            {valsArray.join(' / ')}
        </p>
    );
};
PartnerStats.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
    name: PropTypes.string
};
export default PartnerStats;
